import { render, staticRenderFns } from "./StatePaused.vue?vue&type=template&id=573574ba&scoped=true&"
import script from "./StatePaused.vue?vue&type=script&lang=js&"
export * from "./StatePaused.vue?vue&type=script&lang=js&"
import style0 from "./StatePaused.vue?vue&type=style&index=0&id=573574ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573574ba",
  null
  
)

export default component.exports